import { FC } from 'react'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { TrophyCard } from '~/components/TrophyCard/TrophyCard'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'
import styles from './FeaturedAwards.module.scss'

interface Props {
  trophies: ComponentTrophyDto[]
}

export const FeaturedAwards: FC<Props> = ({ trophies }) => {
  const { t } = useTranslation('featured_awards')

  if (trophies.length === 0) {
    return null
  }

  return (
    <section id="featured-awards" className={ styles.featuredAwards }>
      <div className={ styles.featuredAwards__header }>
        <h1 className={ styles.featuredAwards__headerTitle }>
          { t('header_title') }
          <small className={ styles.featuredAwards__headerSubtitle }>
            { t('header_subtitle') }
          </small>
        </h1>

        <Link
          className={ styles.featuredAwards__headerLink }
          href="/trophies"
          passHref={ true }
        >
          { t('header_see_all') } { }
          <FontAwesomeIcon icon={ faArrowUpRightFromSquare } />
        </Link>
      </div>

      <div className={ styles.featuredAwards__list }>
        { trophies.map((trophy) => (
          <TrophyCard
            key={ trophy.id }
            trophyDto={ trophy }
            appearance="museumGallery"
          />
        )) }
      </div>
    </section>
  )
}
